import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { FaTimes } from "react-icons/fa";
import { rejectPurchaseOrder, getPurchaseOrder } from "redux/erp/purchaseOrderSlice";
import { Modal, Button, FormInput } from 'components/common';

const RejectForm = ({ show, onHide, purchaseOrder }) => {
  const dispatch = useDispatch();
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async () => {
    if (!comment.trim()) { toast.warning("Please enter a rejection reason."); return; }
    setBusy(true);
    try {
      await dispatch(rejectPurchaseOrder({ id: purchaseOrder.id, comment })).unwrap();
      await dispatch(getPurchaseOrder(purchaseOrder.id));
      toast.success("Purchase order rejected.");
      onHide();
    } catch (e) { toast.error(e?.error || e?.message || "Rejection failed."); }
    finally { setBusy(false); }
  };

  return (
    <Modal show={show} onHide={onHide} title={`Reject ${purchaseOrder?.code}`} size="md"
      footer={<>
        <Button variant="secondary" size="sm" disabled={busy} onClick={onHide}>Cancel</Button>
        <Button variant="danger" size="sm" leftIcon={FaTimes} disabled={busy} onClick={onSubmit}>Reject</Button>
      </>}>
      <div className="geist-scope">
        <FormInput label="Rejection reason" required type="textarea" rows={3} value={comment} onChange={(e) => setComment(e.target.value)} />
      </div>
    </Modal>
  );
};

RejectForm.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  purchaseOrder: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    code: PropTypes.string,
  }).isRequired,
};

export default RejectForm;
